<template>
  <el-dialog title="评分" :visible.sync="dialogVisible" width="35%" center>
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="appraiseInfo">
        <el-tab-pane label="总体评估" name="first">
          <div class="menu1">
            <div class="block" style="border-bottom: 1px solid #E8E8E8;padding-bottom: 20px;">
              <div class="demonstration">总体评价</div>
              <div class="icon">
                <el-rate :disabled="!edit" v-model="appraiseInfo.SCORE"></el-rate>
              </div>
            </div>
            <div class="block" v-for="(item, index) in allAppraise ? allAppraise : []" :key='index'>
              <div class="demonstration">{{item.ITEMNAME}}</div>
              <div class="icon">
                <el-rate :disabled="!edit" v-model="item.SCORE"></el-rate>
              </div>
            </div>
            <div class="block">
              <div class="demonstration">总体评价</div>
              <div class="icon">
                <el-input :disabled="!edit" type="textarea" :rows="2" placeholder="请输入内容" v-model="appraiseInfo.COMMENT">
                </el-input>
              </div>
            </div>
            <div style="height: 20px;"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="单项评估" name="second">
          <div class="menu2">
            <div class="block">
              <span class="demonstration" style="line-height: 30px;">选择评价人员</span>
              <div class="icon">
                <el-select size="small" v-model="people" placeholder="请选择">
                  <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="height: 20px;"></div>
            <el-scrollbar style="height: 400px;">
              <template v-for="(item, index) in groupSymbol">
                <el-card :key="index" shadow="never" :body-style="{ padding: '20px' }">
                  <div class="title" style="font-weight: 700;">{{item}}</div>
                  <div class="block" v-for="(obj, num) in selectedList[index]" :key="num">
                    <span class="demonstration">{{obj.ITEMNAME}}</span>
                    <el-rate :disabled="!edit" class="icon" v-model="obj.SCORE"></el-rate>
                  </div>
                </el-card>
                <div :key="item.groupId" style="height: 5px;"></div>
              </template>
            </el-scrollbar>
          </div>
        </el-tab-pane>
      </el-tabs>
    <div style="position: absolute;top: 135px;right: 5%;" v-if="appraiseInfo">
      <el-button @click="edit = true">编辑</el-button>
      <el-button type="primary" @click="submit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    UpdateScoreGroup,
    SaveTaskScoreInfo
  } from '@/api/modules/basicData/task'
  export default {
    components: {

    },
    data() {
      return {
        listHeight: '',
        activeName: 'first', //dialog页数
        people: null,
        selectedList: [],
        edit: false,
        dialogVisible: false
      }
    },
    props: ['appraiseInfo'],
    computed: {
      allAppraise() {
        if (!this.appraiseInfo.DetailList) return
        return this.appraiseInfo.DetailList.filter(item => {
          return item.SCORETYPE === 0
        })
      },
      partAppraise() {
        if (!this.appraiseInfo.DetailList) return
        return this.appraiseInfo.DetailList.filter(item => {
          return item.SCORETYPE === 1
        })
      },
      toUserList() { //对被评价人不同对任务评价Item进行分组
        if (!this.partAppraise) return
        let userIdList = [] //id集合
        let idFilterList = [
          [],
          []
        ] //id筛选列表
        this.partAppraise.forEach(item => {
          let index = userIdList.indexOf(item.TOUSERID)
          if (index > -1) {
            idFilterList[index].push(item)
          } else {
            userIdList.push(item.TOUSERID)
            let num = userIdList.indexOf(item.TOUSERID)
            idFilterList[num].push(item)
          }
        })
        return idFilterList
      },
      options() {
        if (!this.partAppraise) return
        let userIdList = [] //id集合
        let list = []
        this.partAppraise.forEach(item => {
          let index = userIdList.indexOf(item.TOUSERID)
          if (index === -1) {
            userIdList.push(item.TOUSERID)
            list.push({
              value: item.TOUSERID,
              label: item.TOUSERNAME
            })
          }
        })
        return list
      },
      groupByList() {
        if (!this.toUserList) return
        let list = []
        this.toUserList.forEach((item, num) => {
          list.push([])
          let groupIdList = []
          item.forEach(obj => {
            let index = groupIdList.indexOf(obj.GROUPID)
            if (index === -1) {
              groupIdList.push(obj.GROUPID)
            }
          })
          groupIdList.forEach(id => {
            let partList = item.filter(obj => {
              return obj.GROUPID === id
            })
            list[num].push(partList)
          })
        })
        return list
      },
      symbol() {
        if (!this.groupByList) return
        let list = []
        this.groupByList.forEach((arr, num) => {
          if (arr.length === 0) {
            list.push(null)
          } else {
            list.push(arr[0][0].TOUSERID)
          }
        })
        return list
      },
      groupSymbol() {
        if (!this.selectedList) return
        let list = []
        this.selectedList.forEach(arr => {
          list.push(arr[0].GROUPNAME)
        })
        return list
      }
    },
    methods: {
      handleClick() {
        console.log(this.groupByList)
      },
      submit() {
        SaveTaskScoreInfo(this.appraiseInfo).then(res => {
          if (res.ResultCode === 1) {
            this.edit = false
            this.dialogVisible = false
            this.$message({
              message: '评分修改成功',
              type: 'success'
            });
          } else {
            this.$message.error('修改评分失败！');
          }
        })
      }
    },
    watch: {
      people(newValue) {
        let index = this.symbol.indexOf(newValue)
        this.selectedList = this.groupByList[index]
      }
    },
    created() {
      let a = $(window).height();
      this.listHeight = "height:" + (a - 130) + "px;";
    },
    mounted() {

    }
  }
</script>

<style scoped>
  .appraiseInfo>>>.el-scrollbar__wrap {
    overflow-x: auto;
  }

  .block {
    display: flex;
    margin-top: 20px;

    .demonstration {
      width: 30%;
      text-align: right;
    }

    .icon {
      width: 70%;
      padding-left: 15px;
    }
  }
</style>
